import { Paper, Typography, Button, TableContainer, CircularProgress } from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent, { TablePropType } from "../../component/TableComponent";
import moment from "moment";
import { useEffect,MouseEvent } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import useRepotFile from "../../hooks/reportFileHook";
import {encounterWiseCollectionReportExcel,encounterWiseCollectionReportPdf, encounterWiseCollectionSearch } from "../services";

const EncounterWiseCollectionReport = () => {
      const { control, reset, getValues } = useForm();
      const {
        mutate: getEncounterWiseCollectionReport,
        data: doctorWiseBillingReportData,
        isLoading: reportLoading,
        reset:resetMutation
      } = useMutation(encounterWiseCollectionSearch)
    
      const { mutate: getEncounterWiseCollectionReportPdf, isLoading: pdfLoading } =
        useRepotFile({
          apiFunction: encounterWiseCollectionReportPdf,
          responseFileKey:"file"
        });
      const { mutate: getDailyRevenueReportExcel, isLoading: excelLoading } =
        useRepotFile({
          apiFunction: encounterWiseCollectionReportExcel,
          fileType: "xlsx",
        });
    
      const onChange = () => {
        const data = getValues();
        if (data?.fromDate && data?.toDate) {
            getEncounterWiseCollectionReport(data as { fromDate: string; toDate: string });
        }else{
          resetMutation()
        }
      };
    
      const clearForm = () => {
        reset({
          fromDate: "",
          toDate: "",
        });
        resetMutation()
      };
    
      const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
        const fileType = e.currentTarget.dataset.filetype;
        const allData = getValues();
        if (fileType === "pdf") {
          getEncounterWiseCollectionReportPdf({
            fromDate: allData.fromDate,
            toDate: allData.toDate,
          });
        } 
        else {
          getDailyRevenueReportExcel({
            fromDate: allData.fromDate,
            toDate: allData.toDate,
          });
        }
      };
      useEffect(() => {
        getEncounterWiseCollectionReport({
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        });
        reset({
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        });
      }, []);
   return (
        <div className="px-3 py-4 flex flex-col gap-3">
          <Paper>
            <div className="p-4 border-b">
              <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
              Encounter Wise Collection Report
              </Typography>
            </div>
            <form
              // onSubmit={handleSubmit(onSubmit)}
              className="grid grid-cols-2 gap-3 p-4"
            >
              <CustomFormField
                control={control}
                element="datepicker"
                name="fromDate"
                fieldProps={{ label: "From Date" }}
                rules={{ required: "From Date is required", onChange }}
              />
              <CustomFormField
                control={control}
                element="datepicker"
                name="toDate"
                fieldProps={{ label: "To Date" }}
                rules={{ required: "TO Date is required", onChange }}
              />
              <div className="col-span-full flex justify-end items-center gap-3">
                {/* <Button
                  type="submit"
                  disabled={reportLoading}
                  endIcon={reportLoading && <CircularProgress size={18} />}
                >
                  search
                </Button> */}
                <Button color="error" onClick={clearForm}>
                  clear
                </Button>
              </div>
            </form>
          </Paper>
    
          <TableContainer component={Paper}>
            <div className="flex justify-end gap-3 py-2 px-4 border-b">
              <Button
                disabled={pdfLoading || !Boolean(doctorWiseBillingReportData?.response?.length)}
                endIcon={pdfLoading && <CircularProgress size={18} />}
                data-filetype="pdf"
                onClick={getFiles}
              >
                pdf
              </Button>
              <Button
                disabled={excelLoading || !Boolean(doctorWiseBillingReportData?.response?.length)}
                endIcon={excelLoading && <CircularProgress size={18} />}
                data-filetype="excel"
                onClick={getFiles}
              >
                excel
              </Button>
            </div>
            <TableComponent
              loading={reportLoading}
              data={doctorWiseBillingReportData?.response || []}
              tableProps={heading}
            />
          </TableContainer>
        </div>
   )
}

export default EncounterWiseCollectionReport;

const heading:TablePropType= [
  { heading:   "EMR No/Reg No", key: "emrNo" },  
  { heading: "Patient name", key: "patientName" },  
  { heading: "Nationality", key: "nationality" },  
  { heading: "Department", key: "department" },  
  { heading: "Doctor", key: "doctor" },  
  { heading: "Amount", key: "amount",numberType:"round" },  
  { heading: "Patient share", key: "patShare",numberType:"round" },  
  { heading: "Insurance amount", key: "insAmt",numberType:"round" },  
  { heading:"Received amount",key:"receAmt",numberType:"round"},
  { heading:"Discount",key:"disc",numberType:"round"}
]
// "emrNo": "AF00491",
// "nationality": "Christmas Islander",
// "patientName": "Diya KK",
// "department": "Dental",
// "doctor": "DrShabin",
// "amount": 126.0